import './bootstrap';
import '../css/app.css';

import { createRoot } from 'react-dom/client';
import { createInertiaApp, router } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { route as ziggyRoute } from 'ziggy-js';
import { ToastProvider } from '@/Components/Toast';

const appName = import.meta.env.VITE_APP_NAME || 'MEKNOID CRM';

function updateZiggy(props: any) {
    const ziggyConfig = props?.ziggy;

    if (!ziggyConfig || typeof window === 'undefined') {
        return;
    }

    (window as any).route = (
        name?: string,
        params?: unknown,
        absolute?: boolean
    ) =>
        ziggyRoute(
            name as string,
            params as any,
            absolute,
            ziggyConfig
        );
}

createInertiaApp({
    title: (title) => `${title} - ${appName}`,

    resolve: (name: string) =>
        resolvePageComponent(
            `./Pages/${name}.tsx`,
            import.meta.glob('./Pages/**/*.tsx')
        ) as unknown as any,

    setup({ el, App, props }) {
        updateZiggy(props.initialPage.props);

        router.on('navigate', (event) => {
            updateZiggy(event.detail.page.props);
        });

        const root = createRoot(el);
        root.render(
            <ToastProvider>
                <App {...props} />
            </ToastProvider>
        );
    },

    progress: {
        color: '#4f46e5',
        showSpinner: true,
    },
});